import store from "../store";
import { APIService } from "./api";
const apiService = new APIService();

export class APIServiceFeedback {
  createFeedback(data) {
    var config = {
      url: "/feedback",
      method: "post",
      headers: { "x-api-key": data.token, "content-type": "application/json" },
      data: {
        feedback: data.feedback_text,
        contact: "",
        ip_address: "",
        feedback_rating: data.feedback_rating,
        referral_rating: data.referral_rating
      }
    };
    return apiService.api(config);
  }

  deleteFeedback(feedbackID) {
    var config = {
      url: "/feedback/" + feedbackID,
      method: "delete",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  deleteFeedbackIsSpam(feedbackID) {
    var config = {
      url: "/feedback/" + feedbackID + "/isspam",
      method: "delete",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  // searchFeedback (propertyID, keywords, page) {
  //   var config = {
  //     url: '/property/' + propertyID + '/feedback/search/page/' + page,
  //     method: 'post',
  //     headers: {'x-access-token': store.getters.token,
  //       'content-type': 'application/json'},
  //     data: {
  //       keywords: keywords
  //     }
  //   };
  //   return apiService.api(config);
  // }

  getFeedback(propertyID, page, sentimentScore, customerJourneyID) {
    var config = {
      url: "/property/" + propertyID + "/feedback/page/" + page,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      params: {
        sentiment_score: sentimentScore,
        customer_journey_id: customerJourneyID
      }
    };
    return apiService.api(config);
  }

  getFeedbackSummary(propertyID, page) {
    var config = {
      url: "/property/" + propertyID + "/feedbacksummary/page/" + page,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  searchFeedback(propertyID, keywords, page, categoryID, sentimentScore) {
    var config = {
      url: "/feedback/search",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      },
      params: {
        keywords: keywords,
        page: page,
        property_id: propertyID,
        category_id: categoryID,
        sentiment_score: sentimentScore
      }
    };
    return apiService.api(config);
  }
}
